import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { INewslettersResponse, INewslettersQuery } from '@types'

const LIST_NEWSLETTERS_QUERY = gql`
  query Query($input: ListNewslettersInput!) {
    listNewsletters(input: $input) {
      type
      page {
        pageCount
        totalCount
      }
      payload {
        ... on NewsletterListResponse {
          newsletterList {
            title
            createdAt
            content
            id
          }
        }
      }
    }
  }
`

export const useListNewslettersQuery = (variables: INewslettersQuery) => {
  const query = useQuery<INewslettersResponse>(LIST_NEWSLETTERS_QUERY, variables, {
    fetchPolicy: 'network-only'
  })
  return query
}
